import { useTranslation } from 'react-i18next';

export default function PartnersSection() {
  const { t } = useTranslation();

  const partners = [
    { name: 'MTN', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/7a22d505-3823-4b24-acb8-a32e4c6101c4_mtn-logo-footer.svg' },
    { name: 'Moov Africa', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/28fb8aca-c442-48d9-9383-37927085d685_compressed_Moov_Africa_logo.webp' },
    { name: 'YAS', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/19f5418b-9665-40a5-96cf-a26cbd8a55e2_Yas_logo_2024.svg' },
    { name: 'Sagemcom', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/a05df4ce-9faf-4983-9def-a0ae80a1144e_compressed_SAGEMCOM_RVB-1024x203.webp' },
    { name: 'Huawei', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/a7b0d3d8-2b1f-43eb-af2e-03ab4edcafc6_compressed_Huawei_Standard_logo.svg.webp' },
    { name: 'ENGIE', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/c53888d4-117e-4a21-9acb-1021133960a3_compressed_Logo-engie.svg.webp' },
    { name: 'Ericsson', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/cc8a3e23-c2d4-43bf-81f5-26e17e61ab62_compressed_Ericsson-Symbole-removebg-preview.webp' },
    { name: 'Linfra', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/73121c1e-77f5-41b3-8ede-42c9c8d91171_compressed_Linfra-Ghana-Limited-removebg-preview.webp' },
    { name: 'STA', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/da38591d-9cfb-4523-ac83-af1926518de4_compressed_1630621882178-removebg-preview.webp' },
    { name: 'AXIAN ENERGY', logo: 'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/0b956cb5-c444-42f0-99d1-2fc98ec2c5cc_compressed_tlchargement__3_-removebg-preview.webp' },
  ];

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-14">
        <div className="text-center">
          <div className="inline-flex items-center border border-primary-300/60 rounded-full px-4 py-1.5 mb-6">
            <span className="text-primary-600 text-xs font-semibold uppercase tracking-wider">{t('partners.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-foreground-950 max-w-3xl mx-auto leading-tight">
            {t('partners.title')}
          </h2>
          <p className="text-foreground-500 mt-4 max-w-xl mx-auto text-sm">
            {t('partners.description')}
          </p>
        </div>
      </div>
      <div className="relative py-12 border-y border-background-200/70">
        <div className="flex animate-marquee">
          {[...partners, ...partners].map((partner, i) => (
            <div key={i} className="flex items-center justify-center shrink-0 mx-10">
              <div className="flex items-center justify-center px-10 py-6 rounded-2xl bg-background-50 border border-background-200/60 min-w-[240px] h-[120px] transition-colors">
                <img src={partner.logo} alt={`Logo ${partner.name}`} className="max-h-16 max-w-[200px] object-contain" loading="lazy" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="relative py-12">
        <div className="flex animate-marquee-reverse">
          {[...partners.slice().reverse(), ...partners.slice().reverse()].map((partner, i) => (
            <div key={i} className="flex items-center justify-center shrink-0 mx-10">
              <div className="flex items-center justify-center px-10 py-6 rounded-2xl bg-background-50 border border-background-200/60 min-w-[240px] h-[120px] transition-colors">
                <img src={partner.logo} alt={`Logo ${partner.name}`} className="max-h-16 max-w-[200px] object-contain" loading="lazy" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}